import React, { forwardRef, memo, useCallback, useState } from "react";
import { InputContainer, InputContainerProps, InputContainerState } from "../InputContainer";
import { TagsContainer, TagsContainerProps } from "./TagsContainer";

export type TagInputProps = Omit<InputContainerProps<TagsContainerProps, HTMLDivElement>, "inputComponent"> & {
  errorText?: string
}

export const TagInput = memo(forwardRef<HTMLDivElement, TagInputProps>((
  {
    hintText,
    errorText,
    inputState,
    checkInputData = () => true,
    ...props
  },
  ref,
) => {
  const [ hasError, setHasError ] = useState(false);

  const wrapperCheckInputData = useCallback(async (value: string | undefined) => {
    const isValid = await checkInputData?.(value);
    setHasError(!isValid);
    return isValid;
  }, [ checkInputData ]);

  return (
    <InputContainer
      {...props}
      checkInputData={wrapperCheckInputData}
      inputState={hasError ? InputContainerState.error : inputState}
      hintText={hasError ? errorText : hintText}
      ref={ref}
      inputComponent={TagsContainer}
    />
  );
}));
